<div class="container-fluid">
  <div class="header-container">
    <div class="page-header"><span
      class="fa fa-truck"></span>{{ 'bikeshop.collections.pick-ups/delivery' | translate }}
    </div>
    <div class="loading" *ngIf="loading">
      <div class="loader"></div>
    </div>
  </div>

  <div *ngIf="!checkingConfiguration && !configured" class="container-fluid margin-bottom-16"
       style="margin-top: 32px;">
    <div class="title">{{'bikeshop.shop_profile.collections.not_configured' | translate}}</div>
    <div>{{'bikeshop.shop_profile.collections.not_configured_message' | translate}}</div>
    <div class="margin-top-16">
      <button pButton type="button" (click)="goToConfiguration()" class="p-button-raised full-width"
              style="max-width: 250px;"
              label="{{ 'bikeshop.shop_profile.collections.take_me_to_collections_configuration' | translate}}"></button>
    </div>
  </div>
  <div *ngIf="configured">
    <div>
      <div class="row" *ngIf="linkedPartners && linkedPartners.length > 1">
        <div class="col-md-4">
          <div class="label">
            {{ 'bikeshop.collections.pick-ups/delivery_fromstore' | translate }}
          </div>
          <div>
            <p-multiSelect [options]="linkedPartners" [(ngModel)]="selectedPartners"
                           placeholder="Select a store"
                           optionLabel="partnerName"
                           (onChange)="updateFilter($event.value)"></p-multiSelect>
          </div>
        </div>
        <div class="col-md-8"></div>
      </div>

      <p-tabView (onChange)="changeTab($event)">
        <p-tabPanel class="tab-panel-button"
                    header="{{'bikeshop.shop_profile.collections.pick_ups'| translate}}"
                    [selected]="tab === 'Collections'">
          <div>
            <div class="flex">
              <div class="float-left">
                <button class="float-left duration-button" [ngClass]="{'selected': duration==='Day'}"
                        (click)="changeDuration('Day')">{{ 'bikeshop.calendar.day' | translate }}</button>
                <button class="float-left duration-button" [ngClass]="{'selected': duration==='Week'}"
                        (click)="changeDuration('Week')">{{ 'bikeshop.calendar.week' | translate }}</button>
              </div>
              <div class="flex" style="margin-left: auto; margin-right: auto;min-width: 400px;">
                <div class="fa fa-chevron-left" (click)="decreaseDate()"></div>
                <div class="center-date">
                  {{ duration === 'Day' ? date.format("ll") : (startWeek.format("MMMM Do") + " to " + endWeek.format("MMMM Do")) }}
                </div>
                <div class="fa fa-chevron-right" (click)="increaseDate()"></div>
              </div>
              <span class="fa hubtiger-print font-button float-right" pTooltip="{{
                'bikeshop.modal.update_job_card.job_card.print_this_job_card'
                  | translate
              }}" tooltipZIndex="10000" tooltipPosition="left" (click)="print()"></span>
            </div>
            <div class="margin-top-32">
              <p-table #collectionTable [columns]="columns" [value]="collectionServicesList">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                      {{ col.header }}
                      <p-sortIcon [field]="col.field" style="vertical-align: middle;">
                      </p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-service let-columns="columns">
                  <tr>
                    <td *ngFor="let col of columns; let i = index">
                      <div *ngIf="col.type == 'jobcardno'">
                        <div (click)="openJobCard(service.serviceID)"><u>
                          {{ service[col.field] }}</u>
                        </div>
                      </div>
                      <div *ngIf="col.type !== 'jobcardno' && col.type !== 'action'">
                        {{
                        col.type === 'date' ? (service[col.field] | date : countryData.AngularDateFormat) : service[col.field]
                        }}
                      </div>
                      <div style="text-align: center;" *ngIf="col.type === 'action'">
                        <p-checkbox [(ngModel)]="service['collected']" [binary]="true"
                                    [disabled]="service['collected'] && true"
                                    (click)="setCollected(service)"></p-checkbox>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="{{'bikeshop.shop_profile.collections.deliveries'| translate}}"
                    [selected]="tab === 'DropOff'">
          <div>
            <div class="flex">
              <div class="float-left">
                <button class="float-left duration-button" [ngClass]="{'selected': duration==='Day'}"
                        (click)="changeDuration('Day')">{{ 'bikeshop.calendar.day' | translate }}</button>
                <button class="float-left duration-button" [ngClass]="{'selected': duration==='Week'}"
                        (click)="changeDuration('Week')">{{ 'bikeshop.calendar.week' | translate }}</button>
              </div>
              <div class="flex" style="margin-left: auto; margin-right: auto;min-width: 400px;">
                <div class="fa fa-chevron-left" (click)="decreaseDate()"></div>
                <div class="center-date">
                  {{ duration === 'Day' ? date.format("ll") : (startWeek.format("MMMM Do") + " to " + endWeek.format("MMMM Do")) }}
                </div>
                <div class="fa fa-chevron-right" (click)="increaseDate()"></div>
              </div>
              <span class="fa hubtiger-print font-button float-right" pTooltip="{{
                'bikeshop.modal.update_job_card.job_card.print_this_job_card'
                  | translate
              }}" tooltipZIndex="10000" tooltipPosition="left" (click)="print()"></span>
            </div>
            <div class="margin-top-32">
              <p-table #collectionTable [columns]="columns" [value]="collectionServicesList">
                <ng-template pTemplate="header" let-columns>
                  <tr>
                    <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                      {{ tab === 'DropOff' ? col.field === 'Collected' ? ('bikeshop.collections.delivered' | translate) : col.header : col.header }}
                      <p-sortIcon [field]="col.field" style="vertical-align: middle;">
                      </p-sortIcon>
                    </th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-service let-columns="columns">
                  <tr>
                    <td *ngFor="let col of columns; let i = index">
                      <div *ngIf="col.type == 'jobcardno'">
                        <div (click)="openJobCard(service.serviceID)"><u>
                          {{ service[col.field] }}</u>
                        </div>
                      </div>
                      <div *ngIf="col.type !== 'jobcardno' && col.type !== 'action'">
                        {{
                        col.type === 'date' ? (service[col.field] | date : countryData.AngularDateFormat) : service[col.field]
                        }}
                      </div>
                      <div style="text-align: center;" *ngIf="col.type === 'action'">
                        <p-checkbox [(ngModel)]="service['collected']" [binary]="true"
                                    [disabled]="service['collected'] && true"
                                    (click)="setCollected(service)"></p-checkbox>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
  </div>
</div>
